import React from 'react'
import { grey } from '@material-ui/core/colors';
import CookieConsent from "react-cookie-consent";
import { PRIMARY } from '../config';
import { Link, Typography } from '@material-ui/core';

export default function CookieConsentPopUp() {
    return (
        <CookieConsent
          location='bottom'
          buttonText='ACCEPT'
          cookieName="moving-indicators-accepted-cookies"
          expires={150}
          style={{ background: PRIMARY }}
          buttonStyle={{ color: '#ffffff', backgroundColor: PRIMARY, borderColor: '#ffffff', borderWidth: 1, borderRadius: 4, borderStyle: 'solid' }}
        >
          <Typography variant='caption' style={{ color: '#ffffff'}}>
            We use cookies to ensure you the best experience. By using our website you agree 
            to our <Link href="https://www.movingindicators.com/cookie_policy" style={{ color: grey[300]}}>Cookie Policy</Link> as well
            that you have read our <Link href='https://www.movingindicators.com/disclaimer' style={{ color: grey[300]}}>Disclaimer</Link> 
            </Typography> 
        </CookieConsent>
    )
}
